import Lulu from '../../assets/images/lulu.webp'
//import Griselle from '../../assets/images/griselle.webp'
import Coral from '../../assets/images/coral.webp'
// import Moses from '../../assets/images/moses.webp'
import Angel from '../../assets/images/angel.webp'
// import Anthony from '../../assets/images/anthony.webp'
// import LuluInvert from '../../assets/images/lulu-inverted.webp'
// import Danny from '../../assets/images/danny.webp'
import Jerry from '../../assets/images/jerry.jpg'
import Lupita from '../../assets/images/lupita.png'

export interface Barber {
    name: string,
    bookingUrl: string,
    image: string
}

export const barbers: Barber[] = [
    {
        name: 'Lulu',
        bookingUrl: 'https://squareup.com/appointments/buyer/widget/ys0bxddu3du8zj/2WYPSWE8ZTKKN',
        image: Lulu,
    }, 
    // {
    //     name: 'Griselle',
    //     bookingUrl: 'https://app.squareup.com/appointments/buyer/widget/drmgrcl0hm2a74/2WYPSWE8ZTKKN',
    //     image: Griselle,
    // }, 
    // {
    //     name: 'Coral',
    //     bookingUrl: 'https://app.squareup.com/appointments/buyer/widget/0g3irdp12yn0qc/2WYPSWE8ZTKKN',
    //     image: Coral,
    // },
    {
        name: 'Lupita',
        bookingUrl: 'https://app.squareup.com/appointments/buyer/widget/lw0nz4ynpws5hf/2WYPSWE8ZTKKN',
        image: Lupita,
    },
    //   {
    //     name: 'Jerry',
    //     bookingUrl: 'https://app.squareup.com/appointments/buyer/widget/wkm2ksvyslhcsa/2WYPSWE8ZTKKN',
    //     image: Jerry,
    // },
    // {
    //     name: 'Angel',
    //     bookingUrl: 'https://app.squareup.com/appointments/buyer/widget/zxnro5mf65unyr/2WYPSWE8ZTKKN',
    //     image: Angel,
    // },
    // {
    //     name: 'Giovani',
    //     bookingUrl: 'https://app.squareup.com/appointments/buyer/widget/ywu6b9od3w59yi/2WYPSWE8ZTKKN',
    //     image: Giovani,
    // },
    // {
    //     name: 'Moses',
    //     bookingUrl: 'https://square.site/appointments/buyer/widget/yk206anh7l7u1p/9X5BKE90G9AJC',
    //     image: Moses,
    // },
    // {
    //     name: 'Danny',
    //     bookingUrl: 'https://square.site/appointments/buyer/widget/4o2ekucfwai977/L560Q0W22YB8R',
    //     image: Danny,
    // },
    // {
    //     name: 'Anthony',
    //     bookingUrl: 'https://app.squareup.com/appointments/buyer/widget/wsj32b478tbsmc/2WYPSWE8ZTKKN',
    //     image: Anthony,
    // }
    // Added Comment to force rebuild of site.

]
